import React, { Component } from 'react';
// import  * as firebase from "firebase";
// import Posts from "./Posts";
import BlogList from './BlogList'


const Jeyu = {
  KnowledgeBase: {
   background: '#fff',
   padding: '20px 0 40px'
  },
  h2: {
   fontSize: 25,
   color: '#014852',
   fontWeight: '500',
   textAlign: 'center',
   margin: '10px 0 30px 0'
  }
}

export default class Blog extends Component {
  // constructor () {
  //   super();
  //   this.state =  {
  //       Posts : [],
  //   }
  // }
  componentDidMount() {
     window.scrollTo(0, 0)
  //  var Ref = firebase.database().ref('posts/')
  //  Ref.on('value', snap => {
  //    this.setState({
  //      Posts: snap.val()
  //    })
  //    snap.forEach((childSnap) => {
  //     console.log(childSnap.val());
  //    this.setState({
  //     title: childSnap.val().title,
  //     slug: childSnap.val().slug,
  //    })
  //   });
  //   console.log(Posts)
  //  })
  //  firebase.database().ref('posts/').orderByChild('id').once('value').then((data) => {
  //
  //    this.setState({
  //      Posts: data.val().reverse()
  //    })
  //
  //  });
  //
  // }
  // createPosts() {
  //   var arr = [];
  //   this.state.Posts.forEach((v, i) => {
  //    arr.push(<Posts key={i} nkey={i} title={v.title} slug={v.slug} img={v.img} name={v.Author.name} summary={v.summary} tag={v.tag} description={v.description} date={v.date} />);
  //   });
  //   return arr;
  }
  componentWillUnmount() {
   window.scrollTo(0, 0)
  }

  render() {
    return (
      <div className="container-fluid" style={Jeyu.KnowledgeBase}>
       <div className="row">
        <h2 style={Jeyu.h2}>JeyuTex知識庫</h2>
           <BlogList />
       </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/View/Blog/Blog.js